<template>
  <div>
    <el-upload
      v-if="isCanEdit"
      ref="upload"
      class="upload-demo"
      :action="uploadUrl"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      multiple
      :limit="10"
      :headers="myHeader"
      :data="myData"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :disabled="!isCanEdit"
    >
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
    <ul v-else class="el-upload-list el-upload-list--text is-disabled">
      <template v-for="item in fileList">
        <li :key="item.snowid" class="el-upload-list__item is-success" @click="handlePreview(item)">
          <a class="el-upload-list__item-name">
            <i class="el-icon-document" />
            {{ item.name }}
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
import config from '@/config'
import axios from 'axios'
import KxjCom from '@/utils/kxjcom'
import pathReq from '@/api/pathlist'
export default {
  props: {
    value: { type: Array, default: () => { return [] } },
    isCanEdit: { type: Boolean, default: true },
    moduleCode: { type: String, default: '' },
    moduleKey: { type: Number, default: null },
    fileType: { type: String, default: '' },
    taskId: { type: Number, default: null }
  },
  data() {
    return {
      fileList: []
    }
  },
  computed: {
    myHeader() {
      return {
        'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
      }
    },
    myData() {
      return {
        moduleCode: this.moduleCode,
        moduleKey: this.moduleKey,
        fileType: this.fileType,
        taskId: this.taskId ?? 0
      }
    },
    uploadUrl() {
      return config.apiHost + '/api/WorkTaskFile/UploadUserFile'
    }
  },
  watch: {
    value: {
      handler(newVal, oleVal) {
        this.fileList = newVal
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.fileList = []
  },
  activated() {
    // const that = this
    // var path = '/api/services/app/WorkTaskTempFileAppServices/GetFileLists' +
    // '?ModuleCode=' + this.moduleCode +
    // '&ModuleKey=' + this.moduleKey +
    // '&FileType=' + this.fileType +
    // '&TaskId=' + this.taskId

    // pathReq.getNoParams(path).then(res => {
    //   debugger
    //   that.fileList = res.data.result
    // })
  },
  methods: {
    handleRemove(file, fileList) {
      var path = '/api/WorkTaskFile/DelTempFile?id=' + file.snowid
      pathReq.dataUpdate(path).then(r => {
        this.$message.success('成功删除附件')
        this.$emit('input', this.fileList)
      })
    },
    handlePreview(file) {
      const that = this
      const loading = that.$loading(KxjCom.loadOptions)
      const url = config.apiHost + '/api/WorkTaskFile/DownloadUserFile?id=' + file.snowid
      const h = that.myHeader
      that.dlProgress = 0
      axios({
        method: 'post',
        url: url,
        // data: { id: row.id },
        responseType: 'blob',
        headers: h,
        onDownloadProgress(progress) {
          that.dlProgress = Math.round(progress.loaded / progress.total * 100)
        }
      }).then((res) => {
        var content = res.data
        var blob = new Blob([content])
        var fileName = file.name // 要保存的文件名称
        if ('download' in document.createElement('a')) {
          // 非IE下载
          var elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }

        loading.close()
        this.$message.success('下载成功')
      }).catch(() => {
        loading.close()
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleUploadSuccess(res, file) {
      const { result } = res
      this.fileList.push(result)
      this.$emit('input', this.fileList)
    },
    /** 上传失败 */
    handleUploadError(err) {
      var { error } = JSON.parse(err.message)
      if (error && error.details) {
        this.$message.error(error.details)
      } else {
        this.$message.error('上传出错')
      }
    }
  }
}
</script>
